export default {
  dataIterator: {
    rowsPerPageText: 'Položek na stránku:',
    rowsPerPageAll: 'Vše',
    pageText: '{0}-{1} z {2}',
    noResultsText: 'Nebyly nalezeny žádné záznamy',
    nextPage: 'Další stránka',
    prevPage: 'Předchozí stránka'
  },
  dataTable: {
    rowsPerPageText: 'Položek na stránku:'
  },
  noDataText: 'Nebyly nalezeny žádné záznamy'
}



// WEBPACK FOOTER //
// ./src/locales/cz.js